import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';

import { AppRoutingModule } from './app-routing.module';
import { NgbToastModule } from '@ng-bootstrap/ng-bootstrap';
import { AppComponent } from './app.component';
import { MainLayoutComponent } from './layouts/main-layout/main-layout.component';
import { HomePageComponent } from './pages/home-page/home-page.component';
import { InsightsPageComponent } from './pages/insights-page/insights-page.component';
import { MainHeaderComponent } from './components/main-header/main-header.component';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { MenuItemComponent } from './components/menu-item/menu-item.component';
import { SideMenuComponent } from './components/side-menu/side-menu.component';
import { SpinnerComponent } from './components/spinner/spinner.component';
import { ToastsComponent } from './components/toasts/toasts.component';
import { provideHttpClient, withJsonpSupport } from '@angular/common/http';
import { CommonModule } from '@angular/common';
import { InsightTableComponent } from './components/insight-table/insight-table.component';

@NgModule({
  declarations: [
    AppComponent,
    MainLayoutComponent,
    HomePageComponent,
    InsightsPageComponent,
    MainHeaderComponent,
    MenuItemComponent,
    SideMenuComponent,
    SpinnerComponent,
    ToastsComponent,
    InsightTableComponent,
  ],
  imports: [
    BrowserModule,
    CommonModule,
    AppRoutingModule,
    NgbModule,
    NgbToastModule,
  ],
  providers: [
    provideHttpClient(withJsonpSupport()),
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
